import { Done, StarBorder } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

import { IUnitModel } from '../../../../service/unit/interface/IUnitModel';
import { Colors } from '../../../design/color/Colors';
import { IUnitResultModel } from '../../../../service/unitResult/IUnitResultModel';

export interface IUnitListUserCardProperties {
  card: IUnitModel;
  action: any;
  score: number;
  passingUnitResult: IUnitResultModel;
}
export const UnitListUserCard = observer(({ card, action, score, passingUnitResult }: IUnitListUserCardProperties) => {
  return (
    <>
      {passingUnitResult && (
        <Box
          onClick={() => {
            action(card.id);
          }}
          sx={{
            cursor: 'pointer',
            borderRadius: '8px',
            padding: '8px 16px',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            background:
              passingUnitResult?.isPassed && passingUnitResult?.totalUnitResult !== 0
                ? Colors.withOpacity(Colors.success, 0.12)
                : !passingUnitResult?.isPassed && passingUnitResult?.totalUnitResult !== 0
                ? Colors.bgSurface
                : Colors.withOpacity(Colors.primary, 0.12),
            '&:hover': {
              background:
                passingUnitResult?.isPassed && passingUnitResult?.totalUnitResult !== 0
                  ? Colors.withOpacity(Colors.success, 0.18)
                  : !passingUnitResult?.isPassed && passingUnitResult?.totalUnitResult !== 0
                  ? Colors.bgOverlay
                  : Colors.withOpacity(Colors.primary, 0.18),
            },
          }}
        >
          <Typography sx={{ maxWidth: '250px' }}>{card.settings.titleHeading}</Typography>
          <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
            {passingUnitResult?.isPassed && (
              <Typography sx={{ whiteSpace: 'nowrap' }}>
                {Math.round(passingUnitResult?.totalUnitResult)}
                <span style={{ color: Colors.textSecondary }}> / {Math.round(score)}</span>
              </Typography>
            )}
            {!passingUnitResult?.isPassed && passingUnitResult?.totalUnitResult > 0 && (
              <Typography sx={{ whiteSpace: 'nowrap' }}>
                {Math.round(passingUnitResult.totalUnitResult)}
                <span style={{ color: Colors.textSecondary }}> / {Math.round(score)}</span>
              </Typography>
            )}
            {passingUnitResult?.isPassed && passingUnitResult?.totalUnitResult !== 0 && (
              <Done sx={{ height: '20px', width: '20px', background: Colors.chartSuccess, borderRadius: '50%' }} />
            )}
            {!passingUnitResult?.isPassed && passingUnitResult?.totalUnitResult === 0 && (
              <>
                <Typography>+ {Math.round(score)} </Typography>
                <StarBorder
                  sx={{ height: '20px', width: '20px', background: Colors.primaryActive, borderRadius: '50%' }}
                />
              </>
            )}
          </Box>
        </Box>
      )}
    </>
  );
});
